import React from 'react';
import { Phone, ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section className="bg-[#0c2340] py-20 px-4 relative overflow-hidden" data-id="element-16">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#b87333] opacity-10 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2" data-id="element-17" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-500 opacity-10 rounded-full blur-3xl -translate-x-1/2 translate-y-1/2" data-id="element-18" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-19">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-20">
          Ready to Protect Your Home?
        </h2>
        <p className="text-lg sm:text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-21">
          Contact us today for a free estimate on seamless rain gutter
          installation, repair, or maintenance.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-22">
          <a href="#" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#b87333] hover:bg-[#a0632a] text-white font-bold py-4 px-8 rounded-lg transition-colors shadow-lg shadow-[#b87333]/20" data-id="element-23">
            Request an Estimate
            <ArrowRight className="w-5 h-5" data-id="element-24" />
          </a>
          <a href="tel:7146023634" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-transparent hover:bg-white/10 text-white border-2 border-white font-bold py-4 px-8 rounded-lg transition-colors" data-id="element-25">
            <Phone className="w-5 h-5" data-id="element-26" />
            Call (714) 602-3634
          </a>
        </div>
      </div>
    </section>;
}